import React from 'react';
import { Button } from './ui/button';
import { ArrowRight } from '@phosphor-icons/react';

const CTASection = ({ onOpenModal }) => {
  return (
    <section data-testid="cta-section" className="relative py-24 overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img 
          src="https://images.pexels.com/photos/7433859/pexels-photo-7433859.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" 
          alt="" 
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-[#044B3B]/90"></div>
      </div>
      
      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl sm:text-4xl font-heading font-medium text-white tracking-tight mb-6">
          Protect What Makes Your Brand Unique
        </h2>
        <p className="text-base text-white/70 mb-10 max-w-2xl mx-auto leading-relaxed">
          Trademark your name, logo, or slogan and take the next step toward lasting brand protection.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Button
            data-testid="cta-bottom-register-btn"
            onClick={() => onOpenModal && onOpenModal('Start Registration - Bottom CTA')}
            className="bg-white text-[#044B3B] hover:bg-slate-100 font-semibold text-sm px-8 py-5 rounded-md"
          >
            <span className="flex items-center gap-2">Start Registration <ArrowRight className="h-4 w-4" /></span>
          </Button>
          <Button
            data-testid="cta-bottom-chat-btn"
            onClick={() => window.cd360Api && window.cd360Api.liveChat.showWebWidget()}
            className="bg-transparent border border-white/30 text-white hover:bg-white/10 font-semibold text-sm px-8 py-5 rounded-md"
          >
            Speak with an Attorney
          </Button>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
